import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './components/App';
import './index.css';
document.querySelectorAll('.mp-platzbelegung-public').forEach((el) => {
    const raw = el.dataset.plan;
    if (!raw) {
        return;
    }
    let payload;
    try {
        payload = JSON.parse(raw);
    }
    catch {
        return;
    }
    createRoot(el).render(_jsx(App, { readOnly: true, nutzerTeams: payload.nutzerTeams ?? [], taUrl: payload.taUrl ?? null, initialPlan: {
            plaetze: payload.plaetze,
            teams: payload.teams,
            belegungen: payload.belegungen,
            ausnahmen: payload.ausnahmen ?? [],
            sperren: payload.sperren ?? [],
            settings: payload.settings ?? { saison_start: '', saison_ende: '' },
            saisons: payload.saisons ?? [],
            aktiveSaison: payload.aktiveSaison ?? null,
            schliesszeiten: payload.schliesszeiten ?? [],
        }, startAnsicht: payload.ansicht === 'kalender'
            ? 'liste'
            : payload.ansicht === 'raster'
                ? 'proPlatz'
                : 'woche' }));
});
